var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Select_arrow_up@4x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5B98\\u7F51\\u91CD\\u6784",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4-\\u516C\\u5F00\\u4FE1\\u606F\\u62AB\\u9732-\\u516C\\u53F8\\u6CBB\\u7406\\u6982\\u8981",
    transform: "translate(-558.000000, -172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5DE6\\u4FA7\\u83DC\\u5355",
    transform: "translate(348.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Select_arrow_up",
    transform: "translate(210.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow-input",
    transform: "translate(4.000000, 5.333333)",
    fill: "currentColor",
    fillOpacity: 0.8,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    transform: "translate(4.000007, 2.469987) scale(1, -1) translate(-4.000007, -2.469987) ",
    points: "0 0.94 0.94 0 4.00001333 3.05330667 7.06001333 0 8.00001333 0.94 4.00001333 4.93997333"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrowUp);
export default __webpack_public_path__ + "static/media/Select_arrow_up.4147baa6.svg";
export { ForwardRef as ReactComponent };